import { Observable, of } from 'rxjs';
import { catchError, mergeMap, tap } from 'rxjs/operators';

export function chainLoad<T>(loadFn: () => Observable<T>, after?: (data: T) => void): Observable<unknown> {
  return loadFn().pipe(
    tap(result => after?.(result)),
    mergeMap(() => of(void 0)),
    catchError(() => of(void 0))
  );
} 